/* eslint-disable no-unused-vars */
import { axiosApi } from '@/axios-base'

export const roomOrder = function () {
  return {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
      // 取得營區的基本資料
      ROOM_OVERVIEW ({ commit }, params) {
        return axiosApi
          .post(`/v1/room-overview`, params)
          .then((result) => {
            if (result.data.status !== 'success') {
              return false
            }
            if (result.data.status === 'success') {
              return result.data.data
            }
          })
          .catch((err) => {
            console.log(err)
            return false
          })
      }
    },
    getters: {}
  }
}
